import React, { useEffect, useRef, useState } from "react";
import { Typography, Grid, Stack, Box, IconButton, Snackbar, Tooltip } from "@mui/material";
import CloudUploadOutlinedIcon from "@mui/icons-material/CloudUploadOutlined";
import { GreenContainedButton } from "../../components/ui/Buttons";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { GetUserDetails, PostDocumentUpload } from "../../services/auth.services";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import FileUploadIcon from '@mui/icons-material/FileUpload';
// import CreditCardOutlinedIcon from '@mui/icons-material/CreditCardOutlined';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import AccountBalanceOutlinedIcon from '@mui/icons-material/AccountBalanceOutlined';
import BusinessOutlinedIcon from '@mui/icons-material/BusinessOutlined';
import ContactMailOutlinedIcon from '@mui/icons-material/ContactMailOutlined';
import { formatLabel, truncateText } from "../../utils/utilityFunctions";
// import extractTextFromImage from '../../utils/extractText'

const boxStyle = {
	background: "#FFFFFF",
	p: 3,
	boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.04)",
	borderRadius: "10px",
};

const cardStyle = {
	background: "#FFFFFF",
	p: 2,
	boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.04)",
	border: "1px solid rgba(83, 83, 83, 0.15)",
	borderRadius: "10px",
};

const MAX_FILE_SIZE_MB = 5;
const ALLOWED_TYPES = ["image/jpeg", "image/png", "application/pdf"];

const validateFile = (file) => {
	if (!ALLOWED_TYPES.includes(file?.type)) {
		return `Invalid file type. Only JPEG, PNG, or PDF files are allowed.`;
	}
	if (file.size > MAX_FILE_SIZE_MB * 1024 * 1024) {
		return `File size should not exceed ${MAX_FILE_SIZE_MB}MB.`;
	}
	return null;
};

export default function UploadandSign({ updateStep }) {
	const [files, setFiles] = useState([]);
	const [snackBarAlert, setSnackBarAlert] = useState({ open: false, message: '', severity: 'error' });
	const [IdentificationType, setIdentificationType] = useState(formatLabel(localStorage.getItem('businessOwnerIdType')));
	//let IdentificationType = formatLabel(localStorage.getItem('businessOwnerIdType'));
	const hasRun = useRef(false);

	useEffect(() => {
		if (hasRun.current) return;
		hasRun.current = true;

		const fetchData = async () => {
			try {
				await GetUserDetails(localStorage.getItem("uniqueId")).then((row) => {
					setIdentificationType(formatLabel(row.businessOwnerIdType))
				});;

			} catch (error) {
				console.error('Error', error);;
			}
		};

		if (localStorage.getItem("uniqueId")) {
			fetchData();
		}
		// eslint-disable-next-line
	}, [])

	const handleCloseSnackbar = () => {
		setSnackBarAlert({ ...snackBarAlert, open: false });
	};

	const handleFileChange = async (event, index) => {
		const uploadedFiles = event.target.files[0];

		const error = validateFile(uploadedFiles);
		if (error) {
			setSnackBarAlert({ open: true, message: `${uploadedFiles?.name}: ${error}`, severity: 'error' });
		} else {
			setFiles((prev) => {
				const newFiles = [...prev];
				newFiles[index] = uploadedFiles; // Store file in array at the correct index
				return newFiles;
			});
		}
	};

	const fileLength = IdentificationType === 'Passport' ? 5 : 6;
	const handleUpload = async () => {
		// if (!files.includes(undefined) && files.length > fileLength) {
		const filtered = files.filter(item => item != null);
		if (filtered.length > fileLength) {
			try {
				PostDocumentUpload(files).then((data) => {
					if (data.status === 200) {
						updateStep(5);
					}
				}).catch(error => {
					setSnackBarAlert({ open: true, message: error.message, severity: "error" });
					if (error.httpStatus === "NOT_FOUND") {
						updateStep(2);
					}
				});
			} catch (error) {
				setSnackBarAlert({ open: true, message: "Error uploading documents", severity: "error" });
				console.error('Error', error);;
			}
		} else {
			setSnackBarAlert({ open: true, message: "All Documents are required", severity: "error" });
		}

	};

	return (
		<div>
			<Box sx={boxStyle}>
				<Stack direction="row" spacing={2} sx={{ color: "#093BA7" }} alignItems="center">
					<CloudUploadOutlinedIcon />
					<Typography variant="h5">Please upload the following documents</Typography>
				</Stack>

				<br />
				<Grid container spacing={3}>
					<Grid item xs={12} md={6}>
						<Box sx={cardStyle}>
							<Grid container alignItems='center'>
								<Grid item xs={2} textAlign='center'>
									<ContactMailOutlinedIcon fontSize="large" sx={{ color: "#093BA7" }} />
								</Grid>
								<Grid item xs={6}>
									<Stack spacing={2}>
										<Typography variant="body2">{IdentificationType}</Typography>
										<Typography variant="body2_light">Upload a clear picture of the <b>(front)</b> {IdentificationType === 'Passport' ? '' : (<span>and <b>(back)</b></span>)} of your {IdentificationType}</Typography>
										<Tooltip title={files[0]?.name} arrow>
											<Typography variant="body2_light" sx={{ color: '#093BA7' }}>{files[0] ? truncateText(files[0]?.name, 20) : ''}</Typography>
										</Tooltip>
										<Tooltip title={files[1]?.name} arrow>
											<Typography variant="body2_light" sx={{ color: '#093BA7' }}>{files[1] ? truncateText(files[1]?.name, 20) : ''}</Typography>
										</Tooltip>
									</Stack>
								</Grid>
								<Grid item xs={4} textAlign='right'>
									<IconButton component="label">
										<Stack>
											<FileUploadIcon fontSize="large" />
											<input type="file" hidden onChange={(e) => handleFileChange(e, 0)} />
											{IdentificationType === 'Passport' ? '' : (<Typography variant="body2_light">front</Typography>)}
										</Stack>

									</IconButton>
									{IdentificationType === 'Passport' ? '' : (
										<IconButton component="label">
											<Stack>
												<FileUploadIcon fontSize="large" />
												<input type="file" hidden onChange={(e) => handleFileChange(e, 1)} />
												<Typography variant="body2_light">back</Typography>
											</Stack>
										</IconButton>
									)}
								</Grid>
							</Grid>
						</Box>
					</Grid>
					{/* {IdentificationType === 'Passport' ? '' : (
						<Grid item xs={12} md={6}>
							<Box sx={cardStyle}>
								<Grid container alignItems='center'>
									<Grid item xs={2} textAlign='center'>
										<CreditCardOutlinedIcon fontSize="large" sx={{ color: "#093BA7" }} />
									</Grid>
									<Grid item xs={8}>
										<Stack spacing={2}>
											<Typography variant="body2">Identity Document Back</Typography>
											<Typography variant="body2_light">Upload a clear picture of the <b>back</b> of your {IdentificationType}</Typography>
											<Typography variant="body2_light" sx={{ color: '#093BA7' }}>{files[1] ? files[1]?.name : ''}</Typography>
											<Typography variant="body2_light" sx={{ color: '#093BA7' }}>{files[2] ? files[2]?.name : ''}</Typography>
										</Stack>
									</Grid>
									<Grid item xs={2} textAlign='right'>
										<IconButton component="label">
											<FileUploadIcon fontSize="large" />
											<input type="file" hidden onChange={(e) => handleFileChange(e, 1)} />
										</IconButton>
									</Grid>
								</Grid>
							</Box>
						</Grid>
					)} */}
					<Grid item xs={12} md={6}>
						<Box sx={cardStyle}>
							<Grid container alignItems='center'>
								<Grid item xs={2} textAlign='center'>
									<HomeOutlinedIcon fontSize="large" sx={{ color: "#093BA7" }} />
								</Grid>
								<Grid item xs={8}>
									<Stack spacing={2}>
										<Typography variant="body2">Proof of Address</Typography>
										<Typography variant="body2_light">Recent utility bill or official document showing your address</Typography>
										<Tooltip title={files[2]?.name} arrow>
											<Typography variant="body2_light" sx={{ color: '#093BA7' }}>{files[2] ? truncateText(files[2]?.name, 20) : ''}</Typography>
										</Tooltip>
									</Stack>
								</Grid>
								<Grid item xs={2} textAlign='right'>
									<IconButton component="label">
										<FileUploadIcon fontSize="large" />
										<input type="file" hidden onChange={(e) => handleFileChange(e, 2)} />
									</IconButton>
								</Grid>
							</Grid>
						</Box>
					</Grid>
					<Grid item xs={12} md={6}>
						<Box sx={cardStyle}>
							<Grid container alignItems='center' spacing={2}>
								<Grid item xs={2} textAlign='center'>
									<AccountBalanceOutlinedIcon fontSize="large" sx={{ color: "#093BA7" }} />
								</Grid>
								<Grid item xs={10}>
									<Stack spacing={2}>
										<Typography variant="body2">Bank Statement</Typography>
										<Typography variant="body2_light">Last 3 months of bank statements in PDF format</Typography>
									</Stack>
								</Grid>
								<Grid item xs={2}>
								</Grid>
								<Grid item xs={10}>
									<Stack justifyContent="flex-start" alignItems="center" direction="row">
										<IconButton component="label">
											<FileUploadIcon fontSize="large" />
											<input type="file" hidden onChange={(e) => handleFileChange(e, 3)} />
										</IconButton>
										<Stack spacing={1}>
											<Typography variant="body2_light">Bank Statement 1</Typography>
											<Tooltip title={files[3]?.name} arrow>
												<Typography variant="body2_light" sx={{ color: '#093BA7' }}>{files[3] ? truncateText(files[3]?.name, 20) : ''}</Typography>
											</Tooltip>
										</Stack>

									</Stack>

									<Stack justifyContent="flex-start" alignItems="center" direction="row">
										<IconButton component="label">
											<FileUploadIcon fontSize="large" />
											<input type="file" hidden onChange={(e) => handleFileChange(e, 4)} />
										</IconButton>
										<Stack spacing={1}>
											<Typography variant="body2_light">Bank Statement 2</Typography>
											<Tooltip title={files[4]?.name} arrow>
												<Typography variant="body2_light" sx={{ color: '#093BA7' }}>{files[4] ? truncateText(files[4]?.name, 20) : ''}</Typography>
											</Tooltip>
										</Stack>
									</Stack>
									<Stack justifyContent="flex-start" alignItems="center" direction="row">
										<IconButton component="label">
											<FileUploadIcon fontSize="large" />
											<input type="file" hidden onChange={(e) => handleFileChange(e, 5)} />
										</IconButton>
										<Stack spacing={1}>
											<Typography variant="body2_light">Bank Statement 3</Typography>
											<Tooltip title={files[5]?.name} arrow>
												<Typography variant="body2_light" sx={{ color: '#093BA7' }}>{files[5] ? truncateText(files[5]?.name, 20) : ''}</Typography>
											</Tooltip>
										</Stack>
									</Stack>
								</Grid>
							</Grid>
						</Box>
					</Grid>
					<Grid item xs={12} md={6}>
						<Box sx={cardStyle}>
							<Grid container alignItems='center'>
								<Grid item xs={2} textAlign='center'>
									<BusinessOutlinedIcon fontSize="large" sx={{ color: "#093BA7" }} />
								</Grid>
								<Grid item xs={8}>
									<Stack spacing={2}>
										<Typography variant="body2">Business Document</Typography>
										<Typography variant="body2_light">Official business registration or incorporation certificate</Typography>
										<Typography variant="body2_light" sx={{ color: '#093BA7' }}>{files[6] ? truncateText(files[6]?.name, 20) : ''}</Typography>
									</Stack>
								</Grid>
								<Grid item xs={2} textAlign='right'>
									<IconButton component="label">
										<FileUploadIcon fontSize="large" />
										<input type="file" hidden onChange={(e) => handleFileChange(e, 6)} />
									</IconButton>
								</Grid>
							</Grid>
						</Box>
					</Grid>
				</Grid>
			</Box>

			<br />
			<Stack justifyContent="flex-end" alignItems="flex-end">
				<GreenContainedButton variant="contained" onClick={handleUpload} endIcon={<ArrowForwardIosIcon />}>
					Upload Documents
				</GreenContainedButton>
			</Stack>
			<br></br>
			<Snackbar
				open={snackBarAlert.open}
				onClose={handleCloseSnackbar}
				anchorOrigin={{ vertical: "top", horizontal: "left" }}
				sx={{ top: "0 !important", left: "0 !important" }}
				autoHideDuration={6000}
			>
				<Box
					onClose={handleCloseSnackbar}
					sx={{ width: "100vw", background: "#F33535", p: 0.5 }}
				>
					<Stack
						direction="row"
						spacing={2}
						sx={{
							width: "100%",
							textAlign: "center",
							alignItems: "center",
							justifyContent: "center",
							color: "#FFFFFF",
						}}
					>
						<CancelOutlinedIcon fontSize="small" />
						<Typography variant="body2">{snackBarAlert.message}</Typography>
					</Stack>
				</Box>
			</Snackbar>
		</div>
	);
}
